"use strict";

var _ = require("lodash");

module.exports = /* @ngInject */ function() {
  var that = this;

  var linkTypes = {
    subscriber: 1,
    publisher: 2,
    subscriberAndPublisher: 3,
    notSupported: 4
  };

  var publishAndSubscribeRediWindowTypes = [
    "Redi_Montage Monitor",
    "Redi_Montage II",
    "Redi_REDIPlus QuickTrade",
    "Redi_Option Series Monitor",
    "Redi_Option Montage Monitor"
  ];

  var DEFAULT_TYPE = linkTypes.publisher;

  that.getByRediWindowType = function(rediWindowType) {
    if (_.includes(publishAndSubscribeRediWindowTypes, rediWindowType)) {
      return linkTypes.subscriberAndPublisher;
    }
    return DEFAULT_TYPE;
  };

  that.getNotSupported = function() {
    return linkTypes.notSupported;
  };
};



// WEBPACK FOOTER //
// ./app/infrastructure/factories/sideBySideLinkTypeFactory.js